import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AppProvider, useApp } from "./context/AppContext";
import { AuthProvider } from "./context/AuthContext";
import Home from "./pages/Home";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";

const LanguageGate = ({ children }) => {
  const { language, setLanguage } = useApp();
  if (language) return children;

  const LOGO_URL =
    "https://customer-assets.emergentagent.com/job_timeshare-calculator/artifacts/7gkgelre_LOGOTIPO%20ALTERNATIVO%20blanco.png";

  return (
    <div
      className="ourigen-pattern relative flex min-h-screen flex-col items-center justify-center px-6 text-white"
      data-testid="language-gate"
    >
      <img src={LOGO_URL} alt="Ourigen" className="h-24 w-24 object-contain" />
      <p className="mt-10 text-xs tracking-luxury text-[#D4AF37]">Step 01</p>
      <h1 className="mt-3 max-w-xl text-center font-display text-3xl sm:text-4xl">
        Selecciona tu idioma · Choose your language
      </h1>
      <div className="mt-12 grid w-full max-w-xl grid-cols-1 gap-4 sm:grid-cols-2">
        <button
          type="button"
          onClick={() => setLanguage("es")}
          className="group border border-white/20 bg-white/5 px-8 py-10 text-white backdrop-blur-sm transition-all duration-300 hover:-translate-y-1 hover:border-[#D4AF37] hover:bg-white/10"
          data-testid="gate-lang-es"
        >
          <div className="font-display text-3xl group-hover:text-[#D4AF37]">
            Español
          </div>
          <div className="mt-2 text-xs uppercase tracking-luxury text-white/60">
            ES
          </div>
        </button>
        <button
          type="button"
          onClick={() => setLanguage("en")}
          className="group border border-white/20 bg-white/5 px-8 py-10 text-white backdrop-blur-sm transition-all duration-300 hover:-translate-y-1 hover:border-[#D4AF37] hover:bg-white/10"
          data-testid="gate-lang-en"
        >
          <div className="font-display text-3xl group-hover:text-[#D4AF37]">
            English
          </div>
          <div className="mt-2 text-xs uppercase tracking-luxury text-white/60">
            EN
          </div>
        </button>
      </div>
    </div>
  );
};

function App() {
  useEffect(() => {
    const removeBadge = () => {
      const el = document.getElementById("emergent-badge");
      if (el) el.remove();
    };
    removeBadge();
    const id = setInterval(removeBadge, 500);
    return () => clearInterval(id);
  }, []);

  return (
    <AppProvider>
      <AuthProvider>
        <BrowserRouter>
          <Toaster position="top-right" richColors />
          <Routes>
            <Route
              path="/"
              element={
                <LanguageGate>
                  <Home />
                </LanguageGate>
              }
            />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </AppProvider>
  );
}

export default App;
